<!--
 * @Author: zhaoyang
 * @Date: 2020-10-26 12:12:05
 * @LastEditors: your name
 * @LastEditTime: 2020-09-28 17:29:56
 * @Description: 圖片憑證展示
--><template>
  <div class="upload-view">
    <img
      v-for="img in images"
      :key="img"
      :src="img"
      alt=""
      @click="handlePreview([img])"
    />
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    handlePreview(url) {
      const swipe = document.createElement('div');
      const img = document.createElement('img');

      swipe.setAttribute(
        'style',
        `
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        padding: 15px 0;
        overflow: auto;
        z-index: 11110;
        background: rgba(255, 255, 255, 0.96);
      `
      );

      img.setAttribute('src', url);
      img.setAttribute(
        'style',
        `
        max-width: 100vw;
        max-height: 100vh;
        cursor: zoom-out;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 11110;
        transform: translate3d(-50%, -50%, 0);
      `
      );

      swipe.appendChild(img);

      document.body.appendChild(swipe);
      document.body.setAttribute('style', 'overflow: hidden');

      const loading = this.$loading({
        target: swipe,
        customClass: 'pointer-events__none',
        background: 'rgba(255, 255, 255, 0)',
      });

      img.onload = () => {
        loading.close();
      };

      img.addEventListener('click', () => {
        document.body.removeChild(swipe);
        document.body.removeAttribute('style');
        loading.close();
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.upload-view {
  img {
    width: 112px;
    margin-left: 6px;
    border: 1px solid #e9e9e9;
    cursor: zoom-in;
  }
  img:nth-of-type(1) {
    margin-left: 0;
  }
}
</style>
